const init = () => {

  $(window).scroll(function () {
    if ($('.subtotal-placeholder').length) {
      var scrollBottom = $(window).scrollTop() + $(window).height();
      var elementBottom = $('.subtotal-placeholder').offset().top + 72; // Offset plus height of element

      if (scrollBottom < elementBottom) {
        $('.subtotal').addClass('subtotal--sticky');
      } else {
        $('.subtotal').removeClass('subtotal--sticky');
      }
    }
  });

};

export {
  init
}